<template>
  <span>
    {{ timeFromNow }}
  </span>
</template>

<script lang="ts">
export default {
  name: "ReverseTimer",

  props: {
    seconds: {
      default: 0
    }
  },

  watch: {
    seconds: {
      handler(seconds) {
        this.dynamicSeconds = seconds
        this.restartInterval()
      },
      immediate: true
    }
  },

  data() {
    return {
      timerIntervalId: null,
      dynamicSeconds: 0
    }
  },

  computed: {
    timeFromNow() {
      let timeFromNow
      const { dynamicSeconds } = this

      if (dynamicSeconds > 60 * 60 * 24) {
        timeFromNow = this.$moment(new Date()).add(dynamicSeconds, "seconds").fromNow()
      } else if (dynamicSeconds === 0) {
        timeFromNow = this.getCountdownTimer(dynamicSeconds)

        this.stopInterval()
        this.$emit("finished")
      } else {
        timeFromNow = this.getCountdownTimer(dynamicSeconds)
      }

      return timeFromNow
    }
  },

  methods: {
    getCountdownTimer(timestamp: number): string {
      const hours = Math.floor(timestamp / 60 / 60)
      const minutes = Math.floor(timestamp / 60) - hours * 60
      const seconds = Math.floor(timestamp % 60)
      let formattedTime = [
        hours.toString().padStart(2, "0"),
        minutes.toString().padStart(2, "0"),
        seconds.toString().padStart(2, "0")
      ].join(":")

      if (formattedTime.startsWith("00")) {
        formattedTime = formattedTime.slice(-5)
      }

      return formattedTime
    },

    restartInterval(): void {
      this.stopInterval()

      this.timerIntervalId = setInterval(() => {
        if (this.dynamicSeconds > 1) {
          this.dynamicSeconds -= 1
        } else {
          this.dynamicSeconds = 0
        }
      }, 1000)
    },

    stopInterval(): void {
      clearInterval(this.timerIntervalId)
    }
  },

  beforeDestroy() {
    clearInterval(this.timerIntervalId)
  }
}
</script>
